// ISO-3166-1 alpha-2 country list (deutsche Bezeichnung) + EU/EWR/CH-Whitelist.
// Drittstaat = code NICHT in EU_EWR_CH_CODES (-> §53 AuslBG: Aufenthaltstitel-Pflicht).

export const COUNTRIES = [
  { code: 'AF', de: 'Afghanistan' },
  { code: 'EG', de: 'Ägypten' },
  { code: 'AX', de: 'Ålandinseln' },
  { code: 'AL', de: 'Albanien' },
  { code: 'DZ', de: 'Algerien' },
  { code: 'AS', de: 'Amerikanisch-Samoa' },
  { code: 'VI', de: 'Amerikanische Jungferninseln' },
  { code: 'AD', de: 'Andorra' },
  { code: 'AO', de: 'Angola' },
  { code: 'AI', de: 'Anguilla' },
  { code: 'AQ', de: 'Antarktis' },
  { code: 'AG', de: 'Antigua und Barbuda' },
  { code: 'GQ', de: 'Äquatorialguinea' },
  { code: 'AR', de: 'Argentinien' },
  { code: 'AM', de: 'Armenien' },
  { code: 'AW', de: 'Aruba' },
  { code: 'AZ', de: 'Aserbaidschan' },
  { code: 'ET', de: 'Äthiopien' },
  { code: 'AU', de: 'Australien' },
  { code: 'BS', de: 'Bahamas' },
  { code: 'BH', de: 'Bahrain' },
  { code: 'BD', de: 'Bangladesch' },
  { code: 'BB', de: 'Barbados' },
  { code: 'BY', de: 'Belarus' },
  { code: 'BE', de: 'Belgien' },
  { code: 'BZ', de: 'Belize' },
  { code: 'BJ', de: 'Benin' },
  { code: 'BM', de: 'Bermuda' },
  { code: 'BT', de: 'Bhutan' },
  { code: 'BO', de: 'Bolivien' },
  { code: 'BQ', de: 'Bonaire, Sint Eustatius und Saba' },
  { code: 'BA', de: 'Bosnien und Herzegowina' },
  { code: 'BW', de: 'Botswana' },
  { code: 'BV', de: 'Bouvetinsel' },
  { code: 'BR', de: 'Brasilien' },
  { code: 'VG', de: 'Britische Jungferninseln' },
  { code: 'IO', de: 'Britisches Territorium im Indischen Ozean' },
  { code: 'BN', de: 'Brunei Darussalam' },
  { code: 'BG', de: 'Bulgarien' },
  { code: 'BF', de: 'Burkina Faso' },
  { code: 'BI', de: 'Burundi' },
  { code: 'CV', de: 'Cabo Verde' },
  { code: 'CL', de: 'Chile' },
  { code: 'CN', de: 'China' },
  { code: 'CK', de: 'Cookinseln' },
  { code: 'CR', de: 'Costa Rica' },
  { code: 'CI', de: 'Côte d’Ivoire' },
  { code: 'CW', de: 'Curaçao' },
  { code: 'DK', de: 'Dänemark' },
  { code: 'DE', de: 'Deutschland' },
  { code: 'DM', de: 'Dominica' },
  { code: 'DO', de: 'Dominikanische Republik' },
  { code: 'DJ', de: 'Dschibuti' },
  { code: 'EC', de: 'Ecuador' },
  { code: 'SV', de: 'El Salvador' },
  { code: 'ER', de: 'Eritrea' },
  { code: 'EE', de: 'Estland' },
  { code: 'SZ', de: 'Eswatini' },
  { code: 'FK', de: 'Falklandinseln' },
  { code: 'FO', de: 'Färöer' },
  { code: 'FJ', de: 'Fidschi' },
  { code: 'FI', de: 'Finnland' },
  { code: 'FR', de: 'Frankreich' },
  { code: 'GF', de: 'Französisch-Guayana' },
  { code: 'PF', de: 'Französisch-Polynesien' },
  { code: 'TF', de: 'Französische Süd- und Antarktisgebiete' },
  { code: 'GA', de: 'Gabun' },
  { code: 'GM', de: 'Gambia' },
  { code: 'GE', de: 'Georgien' },
  { code: 'GH', de: 'Ghana' },
  { code: 'GI', de: 'Gibraltar' },
  { code: 'GD', de: 'Grenada' },
  { code: 'GR', de: 'Griechenland' },
  { code: 'GL', de: 'Grönland' },
  { code: 'GP', de: 'Guadeloupe' },
  { code: 'GU', de: 'Guam' },
  { code: 'GT', de: 'Guatemala' },
  { code: 'GG', de: 'Guernsey' },
  { code: 'GN', de: 'Guinea' },
  { code: 'GW', de: 'Guinea-Bissau' },
  { code: 'GY', de: 'Guyana' },
  { code: 'HT', de: 'Haiti' },
  { code: 'HM', de: 'Heard und McDonaldinseln' },
  { code: 'HN', de: 'Honduras' },
  { code: 'HK', de: 'Hongkong' },
  { code: 'IN', de: 'Indien' },
  { code: 'ID', de: 'Indonesien' },
  { code: 'IM', de: 'Insel Man' },
  { code: 'IQ', de: 'Irak' },
  { code: 'IR', de: 'Iran' },
  { code: 'IE', de: 'Irland' },
  { code: 'IS', de: 'Island' },
  { code: 'IL', de: 'Israel' },
  { code: 'IT', de: 'Italien' },
  { code: 'JM', de: 'Jamaika' },
  { code: 'JP', de: 'Japan' },
  { code: 'YE', de: 'Jemen' },
  { code: 'JE', de: 'Jersey' },
  { code: 'JO', de: 'Jordanien' },
  { code: 'KY', de: 'Kaimaninseln' },
  { code: 'KH', de: 'Kambodscha' },
  { code: 'CM', de: 'Kamerun' },
  { code: 'CA', de: 'Kanada' },
  { code: 'KZ', de: 'Kasachstan' },
  { code: 'QA', de: 'Katar' },
  { code: 'KE', de: 'Kenia' },
  { code: 'KG', de: 'Kirgisistan' },
  { code: 'KI', de: 'Kiribati' },
  { code: 'CC', de: 'Kokosinseln' },
  { code: 'CO', de: 'Kolumbien' },
  { code: 'KM', de: 'Komoren' },
  { code: 'CG', de: 'Kongo' },
  { code: 'CD', de: 'Kongo, Demokratische Republik' },
  { code: 'KP', de: 'Korea, Demokratische Volksrepublik (Nordkorea)' },
  { code: 'KR', de: 'Korea, Republik (Südkorea)' },
  { code: 'XK', de: 'Kosovo' },
  { code: 'HR', de: 'Kroatien' },
  { code: 'CU', de: 'Kuba' },
  { code: 'KW', de: 'Kuwait' },
  { code: 'LA', de: 'Laos' },
  { code: 'LS', de: 'Lesotho' },
  { code: 'LV', de: 'Lettland' },
  { code: 'LB', de: 'Libanon' },
  { code: 'LR', de: 'Liberia' },
  { code: 'LY', de: 'Libyen' },
  { code: 'LI', de: 'Liechtenstein' },
  { code: 'LT', de: 'Litauen' },
  { code: 'LU', de: 'Luxemburg' },
  { code: 'MO', de: 'Macau' },
  { code: 'MG', de: 'Madagaskar' },
  { code: 'MW', de: 'Malawi' },
  { code: 'MY', de: 'Malaysia' },
  { code: 'MV', de: 'Malediven' },
  { code: 'ML', de: 'Mali' },
  { code: 'MT', de: 'Malta' },
  { code: 'MA', de: 'Marokko' },
  { code: 'MH', de: 'Marshallinseln' },
  { code: 'MQ', de: 'Martinique' },
  { code: 'MR', de: 'Mauretanien' },
  { code: 'MU', de: 'Mauritius' },
  { code: 'YT', de: 'Mayotte' },
  { code: 'MK', de: 'Nordmazedonien' },
  { code: 'MX', de: 'Mexiko' },
  { code: 'FM', de: 'Mikronesien' },
  { code: 'MD', de: 'Moldau' },
  { code: 'MC', de: 'Monaco' },
  { code: 'MN', de: 'Mongolei' },
  { code: 'ME', de: 'Montenegro' },
  { code: 'MS', de: 'Montserrat' },
  { code: 'MZ', de: 'Mosambik' },
  { code: 'MM', de: 'Myanmar' },
  { code: 'NA', de: 'Namibia' },
  { code: 'NR', de: 'Nauru' },
  { code: 'NP', de: 'Nepal' },
  { code: 'NC', de: 'Neukaledonien' },
  { code: 'NZ', de: 'Neuseeland' },
  { code: 'NI', de: 'Nicaragua' },
  { code: 'NL', de: 'Niederlande' },
  { code: 'NE', de: 'Niger' },
  { code: 'NG', de: 'Nigeria' },
  { code: 'NU', de: 'Niue' },
  { code: 'MP', de: 'Nördliche Marianen' },
  { code: 'NF', de: 'Norfolkinsel' },
  { code: 'NO', de: 'Norwegen' },
  { code: 'OM', de: 'Oman' },
  { code: 'AT', de: 'Österreich' },
  { code: 'PK', de: 'Pakistan' },
  { code: 'PS', de: 'Palästina' },
  { code: 'PW', de: 'Palau' },
  { code: 'PA', de: 'Panama' },
  { code: 'PG', de: 'Papua-Neuguinea' },
  { code: 'PY', de: 'Paraguay' },
  { code: 'PE', de: 'Peru' },
  { code: 'PH', de: 'Philippinen' },
  { code: 'PN', de: 'Pitcairn' },
  { code: 'PL', de: 'Polen' },
  { code: 'PT', de: 'Portugal' },
  { code: 'PR', de: 'Puerto Rico' },
  { code: 'RE', de: 'Réunion' },
  { code: 'RW', de: 'Ruanda' },
  { code: 'RO', de: 'Rumänien' },
  { code: 'RU', de: 'Russische Föderation' },
  { code: 'BL', de: 'Saint-Barthélemy' },
  { code: 'MF', de: 'Saint-Martin (französischer Teil)' },
  { code: 'PM', de: 'Saint-Pierre und Miquelon' },
  { code: 'SB', de: 'Salomonen' },
  { code: 'ZM', de: 'Sambia' },
  { code: 'WS', de: 'Samoa' },
  { code: 'SM', de: 'San Marino' },
  { code: 'ST', de: 'São Tomé und Príncipe' },
  { code: 'SA', de: 'Saudi-Arabien' },
  { code: 'SE', de: 'Schweden' },
  { code: 'CH', de: 'Schweiz' },
  { code: 'SN', de: 'Senegal' },
  { code: 'RS', de: 'Serbien' },
  { code: 'SC', de: 'Seychellen' },
  { code: 'SL', de: 'Sierra Leone' },
  { code: 'ZW', de: 'Simbabwe' },
  { code: 'SG', de: 'Singapur' },
  { code: 'SX', de: 'Sint Maarten (niederländischer Teil)' },
  { code: 'SK', de: 'Slowakei' },
  { code: 'SI', de: 'Slowenien' },
  { code: 'SO', de: 'Somalia' },
  { code: 'ES', de: 'Spanien' },
  { code: 'LK', de: 'Sri Lanka' },
  { code: 'SH', de: 'St. Helena' },
  { code: 'KN', de: 'St. Kitts und Nevis' },
  { code: 'LC', de: 'St. Lucia' },
  { code: 'VC', de: 'St. Vincent und die Grenadinen' },
  { code: 'ZA', de: 'Südafrika' },
  { code: 'SD', de: 'Sudan' },
  { code: 'GS', de: 'Südgeorgien und die Südlichen Sandwichinseln' },
  { code: 'SS', de: 'Südsudan' },
  { code: 'SR', de: 'Suriname' },
  { code: 'SJ', de: 'Svalbard und Jan Mayen' },
  { code: 'SY', de: 'Syrien' },
  { code: 'TJ', de: 'Tadschikistan' },
  { code: 'TW', de: 'Taiwan' },
  { code: 'TZ', de: 'Tansania' },
  { code: 'TH', de: 'Thailand' },
  { code: 'TL', de: 'Timor-Leste' },
  { code: 'TG', de: 'Togo' },
  { code: 'TK', de: 'Tokelau' },
  { code: 'TO', de: 'Tonga' },
  { code: 'TT', de: 'Trinidad und Tobago' },
  { code: 'TD', de: 'Tschad' },
  { code: 'CZ', de: 'Tschechien' },
  { code: 'TN', de: 'Tunesien' },
  { code: 'TR', de: 'Türkei' },
  { code: 'TM', de: 'Turkmenistan' },
  { code: 'TC', de: 'Turks- und Caicosinseln' },
  { code: 'TV', de: 'Tuvalu' },
  { code: 'UG', de: 'Uganda' },
  { code: 'UA', de: 'Ukraine' },
  { code: 'HU', de: 'Ungarn' },
  { code: 'UY', de: 'Uruguay' },
  { code: 'UZ', de: 'Usbekistan' },
  { code: 'VU', de: 'Vanuatu' },
  { code: 'VA', de: 'Vatikanstadt' },
  { code: 'VE', de: 'Venezuela' },
  { code: 'AE', de: 'Vereinigte Arabische Emirate' },
  { code: 'US', de: 'Vereinigte Staaten' },
  { code: 'GB', de: 'Vereinigtes Königreich' },
  { code: 'VN', de: 'Vietnam' },
  { code: 'WF', de: 'Wallis und Futuna' },
  { code: 'CX', de: 'Weihnachtsinsel' },
  { code: 'EH', de: 'Westsahara' },
  { code: 'CF', de: 'Zentralafrikanische Republik' },
  { code: 'CY', de: 'Zypern' },
];

// Sortiert nach deutscher Bezeichnung (Locale-aware).
export const COUNTRIES_SORTED = [...COUNTRIES].sort((a, b) => a.de.localeCompare(b.de, 'de'));

// EU (27) + EWR (IS, LI, NO) + CH = 31.
export const EU_EWR_CH_CODES = new Set([
  'AT','BE','BG','CY','CZ','DE','DK','EE','ES','FI','FR','GR','HR','HU','IE','IT',
  'LT','LU','LV','MT','NL','PL','PT','RO','SE','SI','SK',
  'IS','LI','NO','CH',
]);

export function isDrittstaat(code) {
  if (!code) return false;
  return !EU_EWR_CH_CODES.has(String(code).toUpperCase());
}

export function getCountryName(code) {
  if (!code) return '';
  const c = COUNTRIES.find(x => x.code === String(code).toUpperCase());
  return c ? c.de : code;
}
